const API = {
    url: process.env.REACT_APP_BASE_API
};

const ID = {
    searchResultPageId: process.env.REACT_APP_SEARCH_RESULTS_ID,
    searchInputId: process.env.REACT_APP_SEARCH_INPUT_ID,
    homePageCategoriesId: process.env.REACT_APP_HOME_PAGE_CATEGORIES_ID,
    contactFooterId: process.env.REACT_APP_CONTACT_FOOTER_ID
};

const PATH = {
    helpAndSupport: process.env.REACT_APP_HELP_AND_SUPPORT_PATH,
    home: process.env.REACT_APP_HOME_PATH,
    eqSearch: process.env.REACT_APP_EQUINITI_SEARCH_PATH,
    alerts: process.env.REACT_APP_ALERTS_PATH
};

const homePageTitle = 'Help and Support - Equiniti';
const META = {
    homePageTitle: homePageTitle,
    homePageDescription: 'Find answers to questions we are asked here every day at Equiniti',
    unavailablePageTitle: 'Page Unavailable - ' + homePageTitle,
    notFoundPageTitle: 'Page Not Found - ' + homePageTitle
};

const CATEGORY = {
    alerts: process.env.REACT_APP_ALERTS_CATEGORY
};

const ENTITY = {
    alerts: 'alerts',
    categories: 'categories',
    categoryDetails: 'categoryDetails',
    entriesByCategoryId: 'entriesByCategoryId',
    entry: 'entry',
    relatedContent: 'relatedContent'
};

const STATISTICS = {
    url: process.env.REACT_APP_EQUINITI_STATISTICS_URL,
    voteYes: process.env.REACT_APP_EQUINITI_STATISTICS_VOTE_YES,
    voteNo: process.env.REACT_APP_EQUINITI_STATISTICS_VOTE_NO
};

const STATIC = {
    category: process.env.REACT_APP_EQUINITI_STATIC_CATEGORY,
    contactFooter: process.env.REACT_APP_EQUINITI_STATIC_CONTACT_FOOTER
};

const RESOURCES = {
    url: process.env.REACT_APP_RESOURCES_URL
};

const ERRORS = {
    notFound: 404,
    unhandled: 500
};

export {
    API,
    ID,
    PATH,
    META,
    CATEGORY,
    ENTITY,
    STATISTICS,
    STATIC,
    RESOURCES,
    ERRORS
};
